import styles from './header.module.scss';
import { ReactComponent as Logo } from './../svgs/flexifyme-white-logo.svg';

interface HeaderProps {
  userName?: string;
  email?: string;
}

const Header = ({ userName, email }: HeaderProps) => {
  const safeUserName = userName?.trim() || 'User';
  const getInitials = () => {
    const parts = safeUserName.trim().split(' ');

    if (parts.length === 1) return parts[0][0].toUpperCase();

    const first = parts[0];
    const last = parts[parts.length - 1];

    return (first[0] + last[0]).toUpperCase();
  };

  const stringToColor = (str?: string) => {
    const safeStr = str?.trim() || 'User';
    var hash = 0;
    for (var i = 0; i < safeStr.length; i++) {
      hash = safeStr.charCodeAt(i) + ((hash << 5) - hash);
    }
    var colour = '#';
    for (var i = 0; i < 3; i++) {
      var value = (hash >> (i * 8)) & 0xff;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  };

  return (
    <div className={styles.header}>
      <Logo height={40} width={124} />

      <div className={styles.userInfo}>
        <div className={styles.textContainer}>
          <div className={styles.name}>{safeUserName}</div>
          <div className={styles.email}>{email}</div>
        </div>

        <div className={styles.avatar} style={{ backgroundColor: stringToColor(safeUserName) }}>
          {getInitials()}
        </div>
      </div>
    </div>
  );
};

export default Header;
